// src/utils/whatsapp.js
export function normalizePhoneForWa(raw) {
  return String(raw || '').replace(/[^\d]/g, '');
}

export function buildWaLink(text, phone) {
  const msg = encodeURIComponent(text || '');
  const num = normalizePhoneForWa(phone);
  if (num) return `https://api.whatsapp.com/send?phone=${num}&text=${msg}`;
  return `https://api.whatsapp.com/send?text=${msg}`;
}
